import React from 'react'
import { useContent } from '../../services'
import bg14 from '../../assets/images/background/bg-14.png'
import bg15 from '../../assets/images/background/bg-15.png'
import service from '../../assets/images/resource/service-image.png'

const serviceIcons = {
    's-icon-1.png': require('../../assets/images/resource/s-icon-1.png'),
    's-icon-2.png': require('../../assets/images/resource/s-icon-2.png'),
    's-icon-3.png': require('../../assets/images/resource/s-icon-3.png'),
    's-icon-4.png': require('../../assets/images/resource/s-icon-4.png'),
};

function Aboutservice() {
    const { data, loading } = useContent('aboutContent');

    if (loading || !data) return null;

    const { services } = data;
    const leftItems = services.items.slice(0, 2);
    const rightItems = services.items.slice(2, 4);

    return (
        <>
            <section className="services-section">
                <div className="left-bg"><img src={bg14} alt="" title="" /></div>
                <div className="right-bg"><img src={bg15} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>{services.subtitle}</span></div>

                        <div className="pattern-image">
                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>{services.title}</h2>
                    </div>
                    <div className="row clearfix">
                        <div className="s-col col-lg-4 col-md-6 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                {leftItems.map((item, idx) => (
                                    <div key={item.id} className={idx === 0 ? 's-block' : 's-block alternate'}>
                                        <div className="inner">
                                            <div className="icon-box"><img src={serviceIcons[item.icon]} alt={item.title} /></div>
                                            <h4>{item.title}</h4>
                                            <div className="text">{item.text}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="s-col last col-lg-4 col-md-6 col-sm-12">
                            <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                {rightItems.map((item, idx) => (
                                    <div key={item.id} className={idx === 0 ? 's-block alternate' : 's-block'}>
                                        <div className="inner">
                                            <div className="icon-box"><img src={serviceIcons[item.icon]} alt={item.title} /></div>
                                            <h4>{item.title}</h4>
                                            <div className="text">{item.text}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="image-col col-lg-4 col-md-12 col-sm-12">
                            <div className="inner wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image-box"><img src={service} alt="" title="" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Aboutservice
